import "../style/form/doctorform.scss";
import React, { useEffect, useState, useMemo, useRef } from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import { editdoctoruser } from "../redux/reducer/counterslice";
import { useSelector, useDispatch } from "react-redux";
import { doctorlist, patientlist, presignedurl } from "../../text/apidata";
import Swal from "sweetalert2";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { datetimestring } from "../methods/Methods"
import { DatePicker, Stack } from 'rsuite'
import { addDays } from 'date-fns';


export default function PatientForm(props) {
    const editdoctoruserselect = useSelector((state) => state.counter.editdoctoruser);
    const sideactive = useSelector((state) => state.counter.sidebarnav);

    const [creatpasswordvalue, setCreatPasswordValue] = useState("");
    const [preurl, setpreurl] = useState();
    const [birthdate, setbirthdate] = useState(null)
    const [imgfile, setimgfile] = useState();
    const [imgtype, setimgtype] = useState();
    const [creatdoctorinfo, setcreatdoctorinfo] = useState(
        {
            first_name: "",
            last_name: "",
            phonenumber: "",
            gender: "",
            titles: "",
            profile_pic: "",
            branch: "",
            birthdate: "",
        }
    );
    const [gender, setGender] = React.useState("");
    const [type, settype] = React.useState("");
    const [location, setlocation] = useState("");
    const [mr, setmr] = useState("");
    const editdoctor = useDispatch();
    const doctor = useNavigate();
    const [createmailvalue, setCreatEmailvalue] = useState("");
    const [typeerror, settypeerror] = useState(false);
    const [locid, setlocid] = useState(false);

    const [mrerror, setmrerror] = useState(false);
    const [creatfirstname, setCreatefirstname] = useState("");
    const [createfees, setCreatefees] = useState("");
    const [creatlastname, setCreatelastname] = useState("");
    const [creatphoneno, setCreatephoneno] = useState("");
    const [createxperience, setCreateexperience] = useState("");
    const [creatgender, setCreategender] = useState("");
    //
    const [emailerror, setemailerror] = useState(false);
    const [validEmail, setValidEmail] = useState(false);
    const [EmailRequired, setEmailRequired] = useState(false);
    const [passworderror, setPasswordError] = useState(false);
    const [errorfirstname, seterrorfirstname] = useState("");
    const [errorlastname, seterrorlastname] = useState("");
    const [errorfees, seterrorfees] = useState("");

    const [errorphoneno, seterrorphoneno] = useState("");
    const [errorexperience, seterrorexperience] = useState("");
    const [errorgender, seterrorgender] = useState("");

    const [getemail, setgetemail] = useState();
    const editdoctorid = useSelector((state) => state.counter.edituserdoctorid);
    //update
    // console.log(enabledoctoredit, "jhkjhkkjhkkjhkj");
    const [selectedval, setselectedval] = useState([]);
    const [checked, setChecked] = useState(true);
    const [checkedfd, setCheckedfd] = useState(true);

    const [titlesvalue, settitlesvalue] = useState(["Mr.", "Mrs.", "Ms.", "Dr.", "Baby.", "Baby off.", "Master."]);
    //
    const [url, setUrl] = useState();
    console.log(url);
    const [alert, setalert] = useState(false);
    const [CroppImageView, setCroppImageView] = useState(false);
    const [CroppImageViewCount, setCroppImageViewCount] = useState(0);
    const [imgsrc, setImgsrc] = useState();
    const imgRef = useRef(null);
    const [file, setFile] = useState([]);
    const [crop, setCrop] =
        useState();
    const [urlsign, setUrlsign] = useState();
    const editpatientid = useSelector((state) => state.counter.patientid);

    const fixedCropSize = { width: 300, height: 200 };
    const handleChange = (event) => {
        setalert(true);

        setGender(event.target.value);
        // console.log(event.target);
        seterrorgender(false);
        if (event.target.value == 0) {
            const { name, value } = event.target;
            // console.log(name, "ooo");
            setCreategender("Male");
            setcreatdoctorinfo({
                ...creatdoctorinfo,
                [name]: value,
            });
        }
        if (event.target.value == 1) {
            const { name, value } = event.target;
            // console.log(name, "ooo");
            setCreategender("Female");
            setcreatdoctorinfo({
                ...creatdoctorinfo,
                [name]: value,
            });
        }
        if (event.target.value == 2) {
            const { name, value } = event.target;
            // console.log(name, "ooo");
            setCreategender("Others");
            setcreatdoctorinfo({
                ...creatdoctorinfo,
                [name]: value,
            });
        }
    };
    const handleChangelocation = (e) => {
        setalert(true);

        const { name, value } = e.target;
        settypeerror(false);
        setlocation(e.target.value);

        setcreatdoctorinfo({
            ...creatdoctorinfo,
            [name]: value,
        });
    };
    const handleChangemr = (event) => {
        setalert(true);
        const { name, value } = event.target;

        console.log(event.target.value);
        // if (event.target.value.length <= 3) {
        setmr(event.target.value);
        setcreatdoctorinfo({
            ...creatdoctorinfo,
            [name]: value,
        });

        // }
        setmrerror(false);
        // console.log(name, "ooo");
    };
    const Ranges = [
        {
            label: 'today',
            value: new Date(),
            closeOverlay: true,
            placement: 'left'
        },
        {
            label: 'yesterday',
            value: addDays(new Date(), -1),
            closeOverlay: true,
            placement: 'left'
        }
    ];

    useEffect(() => {
        props.loaderchange("true");
        axios({
            method: "get",
            url: patientlist + editpatientid + "/",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token") + "",
            },
        })
            .then((res) => {
                // console.log(res.data.data);
                if (res.status == 200) {
                    setGender(res.data.data.gender);
                    settype(res.data.data.type);
                    setlocation(res.data.data.branch);
                    setgetemail(res.data.data.email);
                    const lastname = "last_name";
                    const firstname = "first_name";
                    const email = "email";
                    const phone = "phonenumber";
                    const mrms = "titles";
                    const doctorgender = "gender";
                    setCreatEmailvalue(res.data.data.email);
                    setCreatefirstname(res.data.data.first_name);
                    setCreatefees(res.data.data.fees);
                    setCreatelastname(res.data.data.last_name);
                    setCreatephoneno(res.data.data.phonenumber);
                    setCreateexperience(res.data.data.experience);
                    setCreategender(res.data.data.gender);
                    setChecked(res.data.data.is_active);
                    setCheckedfd(res.data.data.featured_doctor);
                    settype(res.data.data.type);
                    setmr(res.data.data.titles);
                    setUrl(res.data.data.profile_pic);
                    setUrlsign(res.data.data.doctor_signature);
                    setbirthdate(res.data.data.birthdate)
                    setTimeout(() => {
                        setcreatdoctorinfo({
                            ...creatdoctorinfo,
                            [firstname]: res.data.data.first_name,
                            [lastname]: res.data.data.last_name,
                            [email]: res.data.data.email,
                            [phone]: res.data.data.phonenumber,
                            [doctorgender]: res.data.data.gender,
                            [mrms]: res.data.data.titles,
                            profile_pic: res.data.data.profile_pic,
                            branch: res.data.data.branch,
                            birthdate: res.data.data.birthdate,
                        });
                    }, 200);

                    props.loaderchange("false");
                }
            })
            .catch((error) => {
                console.log(error);
                props.loaderchange("false");
            });
    }, []);
    const formvalidation = (e) => {
        setalert(true);

        setemailerror(true);


        if (e.target.name == "first_name") {
            const { name, value } = e.target;
            const re = /^[A-Za-z ]+$/;
            if (value === "" || re.test(value)) {
                setCreatefirstname(e.target.value);
                seterrorfirstname(false);
                setcreatdoctorinfo({
                    ...creatdoctorinfo,
                    [name]: value.trim().split(/ +/).join(" "),
                });
            }
        }
        if (e.target.name == "last_name") {
            const { name, value } = e.target;
            const re = /^[A-Za-z ]+$/;
            if (value === "" || re.test(value)) {
                setCreatelastname(e.target.value);
                seterrorlastname(false);
                setcreatdoctorinfo({
                    ...creatdoctorinfo,
                    [name]: value,
                });
            }
        }
        if (e.target.name == "phonenumber") {
            const { name, value } = e.target;
            setCreatephoneno(e.target.value);
            seterrorphoneno(false);

            setcreatdoctorinfo({
                ...creatdoctorinfo,
                [name]: value.slice(0, 10),
            });
            if (value.length >= 10) {
                setCreatephoneno(value.slice(0, 10));
            }

            if ((e.target.value = "")) {
                seterrorphoneno(true);
            } else {
                seterrorphoneno(false);
            }
        }

        // if (e.target.name == "password") {
        //     const { name, value } = e.target;
        //     setCreatPasswordValue(e.target.value);
        //     setPasswordError(false);

        //     setcreatdoctorinfo({
        //         ...creatdoctorinfo,
        //         [name]: value,
        //     });
        // }

        if (e.target.name == "email") {
            const { name, value } = e.target;
            setCreatEmailvalue(e.target.value);
            setValidEmail(false);
            setEmailRequired(false);
            setcreatdoctorinfo({
                ...creatdoctorinfo,
                [name]: value,
            });
        }

    };
    const cancelnewuser = () => {
        if (alert) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, revert it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    //Swal.fire("Reverted!", "Given Info has been Removed.", "success");
                    doctor("/Patient");
                    editdoctor(editdoctoruser(""));
                    setalert(false);
                }
            });
        } else {
            doctor("/Patient");
            editdoctor(editdoctoruser(""));
            setalert(false);
        }
    };
    ///
    const selectedImage = (e) => {
        console.log(e.target.files[0]);
        if (e.target.files && e.target.files.length > 0) {
            const reader = new FileReader();
            reader.addEventListener("load", () => setImgsrc(reader.result));
            reader.readAsDataURL(e.target.files[0]);
        }
    };
    const setCompletedCrop = async (c) => {
        const url = await getCroppedImg(imgRef.current, c, "newfile.jpeg");
    };
    const onImageLoaded = (image) => {
        // imgRef = image;
        imgRef.current = image;
    };
    const handleFiles = (e) => {
        selectedImage(e);
        setCroppImageViewCount(1);
        setCroppImageView(true);
        setalert(true);
    };
    const cancel = (e) => {
        setalert(true);
        setUrlsign("");
        setUrl("");
        setcreatdoctorinfo({
            ...creatdoctorinfo,
            profile_pic: "",
        });
    };
    const handleSubmit = (event) => {
        event.preventDefault();
    };
    function getCroppedImg(a, crop, fileName) {
        const image = document.getElementById("localimg");
        const canvas = document.createElement("canvas");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        if (crop) {
            canvas.width = crop.width;
            canvas.height = crop.height;
        } else {
            canvas.width = image.width;
            canvas.height = image.height;
        }
        const ctx = canvas.getContext("2d");
        if (crop) {
            ctx.drawImage(
                image,
                crop.x * scaleX,
                crop.y * scaleY,
                crop.width * scaleX,
                crop.height * scaleY,
                0,
                0,
                crop.width,
                crop.height
            );
        } else {
            ctx.drawImage(
                image,
                scaleX,
                scaleY,
                image.width * scaleX,
                image.height * scaleY,
                0,
                0,
                image.width,
                image.height
            );
        }
        return new Promise((resolve, reject) => {
            canvas.toBlob((blob) => {
                if (!blob) {
                    //reject(new Error('Canvas is empty'));
                    console.error("Canvas is empty");
                    return;
                }
                const croppedFile = new File([blob], "croppedimg.jpg", {
                    type: "image/jpeg",
                });
                if (CroppImageViewCount == 1) {
                    setFile((oldArray) => [
                        ...oldArray,
                        String(URL.createObjectURL(croppedFile)),
                    ]);
                    // setimgfile((oldArray) => [...oldArray, croppedFile]);
                    // setimgtype((oldArray) => [...oldArray, croppedFile.type]);
                    console.log(croppedFile);
                    setimgfile(croppedFile);
                    setimgtype(croppedFile.type);
                    var file = croppedFile;
                    var reader = new FileReader();
                    reader.onloadend = function () {
                        setUrl(reader.result);
                    };
                    reader.readAsDataURL(file);
                    let filename_new = datetimestring()
                    var val = String(Math.floor(Math.random() * 10 ** 4)) + filename_new;

                    var url = {
                        multiple_files: [
                            {
                                ["filename"]:
                                    "assestsfortesting" +
                                    "/" +
                                    String(val) +
                                    String(croppedFile.name).replace(/ +/g, ""),
                                // ["file_type"]: e.target.files[0].type,
                                ["file_type"]: croppedFile.type,
                            },
                        ],
                    };

                    setTimeout(() => {
                        axios({
                            method: "post",
                            url: presignedurl,
                            data: url,
                            headers: {
                                Authorization: "Bearer " + localStorage.getItem("token") + "",
                            },
                        })
                            .then((res) => {
                                setpreurl(String(res.data.data));
                                setcreatdoctorinfo({
                                    ...creatdoctorinfo,
                                    profile_pic: String(res.data.data).split("?")[0],
                                });
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }, 500);
                }

                // console.log(croppedFile);
                blob.name = fileName;
                // setCroppImageViewCount(0);
                setCroppImageView(false);
                // window.URL.revokeObjectURL(this.fileUrl);
                let fileUrl = window.URL.createObjectURL(blob);
                console.log(fileUrl);
                resolve(fileUrl);
            }, "image/jpeg");
        });
    }

    const newusercreat = () => {
        console.log(creatdoctorinfo, preurl, "sdjhkjs")
        if (
            // /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/.test(createmailvalue) &&
            creatdoctorinfo.first_name != "" &&
            creatdoctorinfo.last_name != "" &&
            creatdoctorinfo.phonenumber != "" &&
            creatdoctorinfo.phonenumber.length == 10 &&
            creatdoctorinfo.gender != "" &&
            // creatdoctorinfo.profile_pic != "" &&
            creatdoctorinfo.titles != "" &&
            // creatdoctorinfo.birthdate != "" &&
            // creatdoctorinfo.birthdate != null &&
            creatdoctorinfo.branch != ""
        ) {
            props.loaderchange("true");
            async function editimage() {
                if (preurl && preurl.length > 0) {
                    const resp = await fetch(preurl, {
                        method: "PUT",
                        body: imgfile,
                        headers: {
                            "Content-Type": imgtype,
                            "X-Amz-ACL": "public-read",
                        },
                    }).catch((err) => {
                        console.log(err);
                        return null;
                    });
                }

                axios({
                    method: "put",
                    data: creatdoctorinfo,
                    url: patientlist + editpatientid + "/",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token") + "",
                    },
                })
                    .then((res) => {
                        if (res.status == 200) {
                            setalert(false);

                            doctor("/PatientView");
                            editdoctor(editdoctoruser(""));
                            props.popupalert("true");
                            props.popuptext("Patient Details Updated Successfully");
                            setTimeout(() => {
                                props.popupalert("false");
                            }, 2000);

                            props.loaderchange("false");
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        props.popupalert("true");
                        props.popuptext(error.response.data.status.message);
                        setTimeout(() => {
                            props.popupalert("false");
                        }, 2000);

                        props.loaderchange("false");
                    });
            }
            editimage();
        } else {
            if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/.test(createmailvalue)) {
                setEmailRequired(false);
                setValidEmail(true);
            }
            if (createmailvalue == "" || createmailvalue == null) {
                setEmailRequired(true);
            }
            if (creatpasswordvalue == "") {
                setPasswordError(true);
            }
            if (creatfirstname == "" || creatfirstname == null) {
                seterrorfirstname(true);
            }
            if (createfees == "" || createfees == null) {
                seterrorfees(true);
            }
            if (creatlastname == "" || creatlastname == null) {
                seterrorlastname(true);
            }
            if (
                creatphoneno == "" ||
                creatphoneno == null ||
                creatdoctorinfo.phonenumber.length != 10
            ) {
                seterrorphoneno(true);
                console.log(creatdoctorinfo);
            }

            if (mr == "" || mr == null) {
                setmrerror(true);
            }
            if (creatgender == "" || creatgender == null) {
                seterrorgender(true);
            }
            if (
                creatdoctorinfo.profile_pic == "" ||
                creatdoctorinfo.profile_pic == null
            ) {
                props.popupalert("true");
                props.popuptext("Upload Image to Continue");
                setTimeout(() => {
                    props.popupalert("false");
                }, 2000);
            }
            if (
                creatdoctorinfo.branch == "" ||
                creatdoctorinfo.branch == null
            ) {
                setlocid(true);
            }
        }
    };
    const handlechangedate = (name, value, timeString) => {
        setalert(true);
        setbirthdate(value)
        setcreatdoctorinfo({
            ...creatdoctorinfo,
            birthdate: value.split("T")[0],
        })
    }

    const disableFutureDates = (date) => {
        const today = new Date();
        return date.getTime() > today.getTime();
    };
    return (
        <>
            <div className={sideactive ? "doctorform-sa" : "doctorform"}>
                <div class="card">
                    <div class="card-header">
                        <h5 class="card-title" style={{ padding: "6px", margin: 0 }}>
                            Patient Edit
                        </h5>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm">
                                <form class="row g-3 needs-validation" onSubmit={handleSubmit}>
                                    <div class="col-md-4">
                                        <label for="validationCustom04" class="form-label">
                                            Titles
                                        </label>
                                        <select
                                            class="form-select"
                                            id="validationCustom04"
                                            value={mr}
                                            name="titles"
                                            onChange={handleChangemr}
                                        >
                                            <option selected disabled value="">
                                                Choose...
                                            </option>
                                            {titlesvalue.map((ele) => {
                                                return (
                                                    <option value={ele}>{ele}</option>
                                                )
                                            })}
                                        </select>
                                        <p style={{ fontSize: "12px", color: "red" }}>
                                            {mrerror ? "Title Required" : ""}
                                        </p>
                                        {/* <input
                                            type="text"
                                            className="form-control"
                                            id="validationCustom04"
                                            value={mr}
                                            name="titles"
                                            onChange={handleChangemr}
                                            placeholder="Enter title (e.g., Dr, Mr, Ms, Mrs)"
                                            required
                                        />
                                        <p style={{ fontSize: "12px", color: "red" }}>
                                            {mrerror ? "Title Required" : ""}
                                        </p> */}
                                    </div>
                                    <div class="col-md-4">
                                        <label for="validationCustom01" class="form-label">
                                            First name
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="validationCustomn"
                                            name="first_name"
                                            autoComplete="off"
                                            onKeyDown={(e) => {
                                                if (e.target.value.length === 0 && e.which === 32) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            value={
                                                //  creatdoctorinfo.first_name
                                                creatfirstname
                                            }
                                            onChange={(e) => formvalidation(e)}
                                        // onKeyDown={(e) => {
                                        //   if (e.which == "32") {
                                        //     e.preventDefault();
                                        //   }
                                        // }}
                                        ></input>
                                        <p style={{ fontSize: "12px", color: "red" }}>
                                            {errorfirstname ? "Firstname Required" : ""}{" "}
                                        </p>
                                    </div>
                                    <div class="col-md-4">
                                        <label for="validationCustom02" class="form-label">
                                            Last name
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="last_name"
                                            id="validationCustom02 "
                                            autoComplete="off"
                                            onKeyDown={(e) => {
                                                if (e.target.value.length === 0 && e.which === 32) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            value={
                                                // creatdoctorinfo.last_name
                                                creatlastname
                                            }
                                            onChange={(e) => formvalidation(e)}
                                        // onKeyDown={(e) => {
                                        //   if (e.which == "32") {
                                        //     e.preventDefault();
                                        //   }
                                        // }}
                                        ></input>
                                        {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {errorlastname ? "Lastname Required" : ""}{" "}
                    </p> */}
                                    </div>
                                    <div className="col-md-4">
                                        <label for="validationCustom02" class="form-label">
                                            DOB
                                        </label>

                                        <DatePicker
                                            placement='bottomStart'
                                            align='left'
                                            name='birthdate'
                                            ranges={Ranges}
                                            dateFormat="MMMM d, yyyy"
                                            style={{ width: "100%" }}
                                            disabledDate={disableFutureDates}
                                            onClean={(e) => {
                                                setcreatdoctorinfo("")
                                            }}
                                            onChange={(e) => {
                                                if (e != null) {
                                                    console.log(e)
                                                    const date = new Date(e)
                                                    const timeString = date.toLocaleTimeString('en-US', { timeStyle: 'medium', },)
                                                    var tzoffset = new Date().getTimezoneOffset() * 60000
                                                    var localISOTime = new Date(e - tzoffset,).toISOString().slice(0, -1)
                                                    handlechangedate('task', localISOTime, timeString)
                                                }
                                            }}
                                            value={birthdate != null && birthdate != undefined && birthdate != '' ? new Date(birthdate) : null}
                                        />

                                    </div>
                                    <div class="col-md-4">
                                        <label for="validationCustomUsername" class="form-label">
                                            Email
                                        </label>
                                        <div class="input-group has-validation">
                                            <span
                                                class="input-group-text"
                                                id="inputGroupPrepend"
                                                style={{ borderRadius: "6px 0px 0px 6px" }}
                                            >
                                                @
                                            </span>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="validationCustomUsername"
                                                aria-describedby="inputGroupPrepend"
                                                autoComplete="off"
                                                name="email"
                                                onChange={(e) => formvalidation(e)}
                                                value={
                                                    editdoctoruserselect == "activedoctoredit"
                                                        ? creatdoctorinfo.email
                                                        : null
                                                }
                                            ></input>
                                        </div>
                                        <p style={{ fontSize: "12px", color: "red" }}>
                                            {EmailRequired
                                                ? "Email Required"
                                                : validEmail
                                                    ? "Enter valid Email"
                                                    : ""}{" "}
                                        </p>
                                    </div>
                                    <div class="col-md-4">
                                        <label for="validationCustom03" class="form-label">
                                            PhoneNumber
                                        </label>
                                        <input
                                            type="number"
                                            class="form-control"
                                            id="validationCustom03"
                                            autoComplete="off"
                                            name="phonenumber"
                                            onKeyDown={(evt) =>
                                                ["e", "E", "+", "-"].includes(evt.key) &&
                                                evt.preventDefault()
                                            }
                                            onChange={(e) => formvalidation(e)}
                                            value={
                                                editdoctoruserselect == "activedoctoredit"
                                                    ? creatphoneno
                                                    : creatphoneno
                                            }
                                            onWheel={(e) => {
                                                document.activeElement.blur();
                                            }}
                                        ></input>
                                        <p style={{ fontSize: "12px", color: "red" }}>
                                            {errorphoneno
                                                ? creatphoneno == ""
                                                    ? "Phonenumber Required"
                                                    : "Enter Valid Phonenumber"
                                                : ""}{" "}
                                        </p>
                                    </div>
                                    <div class="col-md-2 mt-4">
                                        <label for="validationCustom04" class="form-label">
                                            Gender
                                        </label>
                                        <select
                                            class="form-select"
                                            id="validationCustom04"
                                            value={gender}
                                            name="gender"
                                            onChange={handleChange}
                                        >
                                            <option selected disabled value="">
                                                Choose...
                                            </option>
                                            <option value={"0"}>Male</option>
                                            <option value={"1"}>Female</option>
                                            <option value={"2"}>Others</option>
                                            <option value={"3"}>Decline to State</option>
                                        </select>
                                        <p style={{ fontSize: "12px", color: "red" }}>
                                            {errorgender ? "Gender Required" : ""}
                                        </p>
                                    </div>
                                    <div class="col-md-2 mt-4">
                                        <label for="validationCustom04" class="form-label">
                                            branch
                                        </label>
                                        <select
                                            class="form-select"
                                            id="validationCustom04"
                                            value={location}
                                            name="branch"
                                            onChange={handleChangelocation}
                                        >
                                            <option selected disabled value="">
                                                Choose...
                                            </option>
                                            <option value={"0"}>VELACHERY</option>
                                            <option value={"1"}>CHETPET</option>
                                            <option value={"2"}>KOLATHUR</option>
                                        </select>
                                        <p style={{ fontSize: "12px", color: "red" }}>
                                            {creatdoctorinfo.branch == "" && typeerror
                                                ? "Type Required"
                                                : ""}
                                        </p>
                                    </div>
                                    <div
                                        class="col-md-6 mt-4"
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-start",
                                        }}
                                    >
                                        <>
                                            {url ? (
                                                <img
                                                    src={url}
                                                    onClick={(e) => {
                                                        window.open(url);
                                                    }}
                                                    className="pointer"
                                                    style={{
                                                        height: 115,
                                                        width: 115,
                                                        marginRight: 25,
                                                        borderRadius: "50%",
                                                    }}
                                                    alt="Image"
                                                />
                                            ) : (
                                                <p style={{ margin: 0, padding: 10 }}>
                                                    Upload Profile Picture
                                                </p>
                                            )}

                                            {!url ? (
                                                <Button
                                                    className="doctorupload"
                                                    variant="contained"
                                                    component="label"
                                                >
                                                    <p>
                                                        Upload Image
                                                        <input
                                                            type="file"
                                                            hidden
                                                            accept="image/png, image/jpeg"
                                                            onChange={(e) => handleFiles(e)}
                                                        />
                                                    </p>
                                                </Button>
                                            ) : (
                                                <></>
                                            )}

                                            {url ? (
                                                <Button
                                                    className="remove"
                                                    variant="contained"
                                                    onClick={(e) => cancel(e)}
                                                // disabled={true}
                                                >
                                                    {" "}
                                                    <p>Remove Image</p>
                                                </Button>
                                            ) : (
                                                ""
                                            )}
                                        </>
                                    </div>
                                    <div className="row">
                                        <div class="col-6">
                                            <button
                                                class="btn btn-primary"
                                                type="submit"
                                                onClick={(e) => {
                                                    newusercreat(e);
                                                }}
                                                disabled={
                                                    editdoctoruserselect == "activedoctoredit" && !alert
                                                        ? true
                                                        : false
                                                }
                                            >
                                                {editdoctoruserselect == "activedoctoredit"
                                                    ? "Update form"
                                                    : "Submit form"}
                                            </button>
                                        </div>
                                        <div class="col-6">
                                            <button
                                                class="btn btn-danger"
                                                style={{ float: "right" }}
                                                onClick={(e) => cancelnewuser(e)}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {CroppImageView && (
                <div className="Cropper_Wrapper">
                    <div className="Cropper_Inner_Wrapper">
                        <ReactCrop
                            src={imgsrc}
                            crop={crop}
                            ruleOfThirds
                            onImageLoaded={onImageLoaded}
                            onChange={(c) => {
                                setCrop(c);
                                console.log(c);
                            }}
                            keepSelection
                            // onComplete={(c) => setCompletedCrop(c)}
                            cropSize={fixedCropSize}
                        >
                            <img src={imgsrc} ref={imgRef} id="localimg" />
                        </ReactCrop>
                    </div>
                    <div className="CropperFooter">
                        <button onClick={(e) => setCroppImageView(false)}>Cancel</button>
                        <button onClick={(e) => setCompletedCrop(crop)}>Save</button>
                    </div>
                </div>
            )}
        </>
    );
}
